import { type Transition, type Variants } from 'framer-motion';

import { EASE_CUBIC } from '@pkg/components/Sections/Profile/StyledThemeProvider/themes/default';

const TRANSLATION_OFFSET = 16;

export enum EmojiPopoverVariant {
    Hidden = 'hidden',
    Show = 'show',
}

function getTranslationFromPlacement(placement) {
    switch (placement) {
        case 'top':
        case 'top-start':
        case 'top-end':
            return {
                translateY: TRANSLATION_OFFSET,
            };
        case 'right':
        case 'right-start':
        case 'right-end':
        default:
            return {
                translateX: TRANSLATION_OFFSET * -1,
            };
        case 'bottom':
        case 'bottom-start':
        case 'bottom-end':
            return {
                translateY: TRANSLATION_OFFSET * -1,
            };
        case 'left':
        case 'left-start':
        case 'left-end':
            return {
                translateX: TRANSLATION_OFFSET,
            };
    }
}

// This uses the currently active "placement" from floating-ui to
// determine which direction it should animate from
export const emojiPopoverVariants: Variants = {
    [EmojiPopoverVariant.Hidden]: ({ placement }) => {
        return {
            opacity: 0,
            scale: 0.9,
            ...getTranslationFromPlacement(placement),
        };
    },
    [EmojiPopoverVariant.Show]: {
        opacity: 1,
        scale: 1,
        translateX: 0,
        translateY: 0,
    },
};

export const emojiPopoverTransition: Transition = {
    ease: EASE_CUBIC,
    duration: 0.3,
};
